import { useEffect, useState, useRef } from "react";
import { doc, getDoc, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/firebase";

function ReadOnlyProfile({ founderId }) {
  const [profile, setProfile] = useState(null);

  // 🔒 Dedupe guard (log only once)
  const loggedView = useRef(false);

  useEffect(() => {
    const load = async () => {
      const snap = await getDoc(doc(db, "users", founderId));
      if (snap.exists()) {
        setProfile(snap.data());

        // ✅ LOG ANALYTICS (EVALUATOR PROFILE VIEW)
        if (!loggedView.current) {
          loggedView.current = true;

          try {
            await addDoc(collection(db, "analytics"), {
              ownerId: founderId,
              eventType: "profile_view",
              source: "evaluator",
              entityType: "profile",
              timestamp: serverTimestamp(),
              userAgent: navigator.userAgent,
            });
          } catch {
            // silent fail — analytics should never break UX
          }
        }
      }
    };

    load();
  }, [founderId]);

  if (!profile) return null;

  return (
    <div className="card" style={{ padding: 24, marginBottom: 24 }}>
      <h3>Founder Profile</h3>

      <p><strong>Founder:</strong> {profile.fullName}</p>
      <p><strong>Email:</strong> {profile.email}</p>
      <p><strong>Role:</strong> {profile.founderRole}</p>
      <p><strong>Startup:</strong> {profile.startupName}</p>
      <p><strong>Description:</strong> {profile.description}</p>

      <div style={{ marginTop: 12 }}>
        <strong>Industries:</strong>
        <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
          {(profile.industries || []).map((i) => (
            <span
              key={i}
              style={{
                padding: "4px 10px",
                background: "#eef2ff",
                borderRadius: 999,
                fontSize: 13,
              }}
            >
              {i}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ReadOnlyProfile;
